import { render, staticRenderFns } from "./Informative.vue?vue&type=template&id=68999a43&"
import script from "./Informative.vue?vue&type=script&lang=js&"
export * from "./Informative.vue?vue&type=script&lang=js&"
import style0 from "./Informative.vue?vue&type=style&index=0&id=68999a43&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports